module.exports = __webpack_public_path__ + "media/images/community_main-86d260a9eaecc96f4be9dc0603aeda9e.jpg";